import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store' 
import axios from 'axios'

import echarts from 'echarts'

Vue.prototype.$echarts = echarts
//重置CSS
import './assets/css/reset.css'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-TW';
import 'element-ui/lib/theme-chalk/index.css';
// 图标字体
import './assets/iconfont/iconfont.css';

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

Vue.prototype.$axios = axios;
axios.defaults.withCredentials =true;


router.beforeEach((to, from, next) => {

  //1：获取用户登录成功后储存的登录标志
  
  let getFlag = sessionStorage.getItem("Flag");
  // localStorage.setItem("Baudit", "isBranch");
  let getBaudit = localStorage.getItem("Baudit");

  //1-1：如果登录标志存在且为isLogin，即用户已登录
  if(getFlag === "isLogin"){
    // 拦截1：修改银行信息拦截：
    if(getBaudit === "isBranch"){

      if(to.fullPath === '/login/loginaudit'){
        next()
      } else {
        next({
          path: '/login/loginaudit'
        })
      }
    } else {
      
      next()
    }

    // Nav 是否隱藏：
    if(to.fullPath === '/login/loginaudit' ){
      store.state.navTF = false;
    } else if(to.fullPath === '/login/agreement' ){
      store.state.navTF = false;
    } else {
      store.state.navTF = true;
    }
    
    //如果已登录，还想想进入登录注册界面，则定向回首页
    if (!to.meta.isLogin) {
      next({
        path: '/login'
      })
    }


  
  //1-2：如果登录标志不存在，即未登录
  } else {

    //1-2-1：用户想进入需要登录的页面，则定向回登录界面
    if(to.meta.isLogin){
      next({
        path: '/',
      })
      // next()
    //1-2-2：用户进入无需登录的界面，则跳转继续
    } else {
      next()
    }

  }

});

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
